module.exports = __webpack_public_path__ + "img/hx.92a92e8f.png";